<template>
<v-container class="pa-0 ma-0" fluid>
  <v-row no-gutters>
    <v-expansion-panels
          v-model="ex_panel"
          accordion
          multiple
          flat
          class="pa-0"
        >
      <v-expansion-panel>
        <v-expansion-panel-header>
            <dd-sub-header>検索条件</dd-sub-header>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
            <v-row no-gutters align-content="center">
                <v-col :cols=3>
                    <v-row no-gutters align-content="center">
                        <v-col class="px-2">
                            <dd-code-text-box
                               label="受注営業所コード/名称"
                               placeholder="名称またはコードで検索"
                               v-model="conditions.juchuEigyoushoCd"
                                :length="10"
                                :required="false"
                                :titleText="営業所コード検索"
                                :valueType="Ctrls.InputTypes.Alphanumeric"/>
                        </v-col>
                    </v-row>
                </v-col>
                <v-col :cols=3>
                    <v-row no-gutters align-content="center">
                        <span style="width:48%" class="px-2">
                            <dd-date-box
                               label="受注日"
                               placeholder="yyyy-mm-dd"
                               v-model="conditions.juchuBiFrom"
                               :length="10"
                               :required="false"
                               :valueType="Ctrls.InputTypes.Date"/>
                        </span>
                        <span style="width:4%" class="mt-2 mp-0">～</span>
                        <span style="width:48%" class="px-2">
                            <dd-date-box
                               label="受注日"
                               placeholder="yyyy-mm-dd"
                               v-model="conditions.juchuBiTo"
                               :length="10"
                               :required="false"
                               :valueType="Ctrls.InputTypes.Date"/>
                        </span>
                    </v-row>
                </v-col>
                <v-col :cols=3>
                    <v-row no-gutters align-content="center">
                        <v-col>
                            <dd-code-text-box
                               label="入力担当コード/名称"
                               placeholder="名称またはコードで検索"
                               v-model="conditions.nyuryokuTantoushaCd"
                               :length="10"
                               :required="false"
                               :titleText="担当コード検索"
                               :valueType="Ctrls.InputTypes.Alphanumeric"/>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
            <v-row no-gutters align-content="center">
                <v-col :cols=3>
                    <v-row no-gutters align-content="center">
                        <v-col class="px-2">
                            <dd-code-text-box
                              label="得意先コード/名称"
                              placeholder="名称またはコードで検索"
                              v-model="conditions.tokuisakiCd"
                              :length="10"
                              :required="false"
                              :titleText="得意先コード検索"
                              :valueType="Ctrls.InputTypes.Alphanumeric"/>
                        </v-col>
                    </v-row>
                </v-col>
                <v-col :cols=3>
                    <v-row no-gutters align-content="center">
                        <span style="width:48%" class="px-2">
                            <dd-date-box
                               label="作業予定日"
                               placeholder="yyyy-mm-dd"
                               v-model="conditions.sagyoYoteiBiFrom"
                               :length="10"
                               :required="false"
                               :valueType="Ctrls.InputTypes.Date"/>
                        </span>
                        <span style="width:4%" class="mt-2 mp-0">～</span>
                        <span style="width:48%" class="px-2">
                            <dd-date-box
                               label="作業予定日"
                               placeholder="yyyy-mm-dd"
                               v-model="conditions.sagyoYoteiBiTo"
                               :length="10"
                               :required="false"
                               :valueType="Ctrls.InputTypes.Date"/>
                        </span>
                    </v-row>
                </v-col>
                <v-col :cols=3>
                    <v-row no-gutters align-content="center">
                        <v-col :cols=6 class="px-2">
                            <dd-text-box
                               label="客先注文番号"
                               placeholder=""
                               v-model="conditions.kyakusakiChumonBango"
                               :length="10"
                               :required="false"
                               :valueType="Ctrls.InputTypes.Alphanumeric"/>
                        </v-col>
                    </v-row>
                </v-col>
                <v-col :cols=3>
                    <v-row no-gutters align-content="center">
                        <v-col :cols=6 class="px-2">
                            <dd-text-box
                               label="作業番号"
                               placeholder=""
                               v-model="conditions.sagyoBango"
                               :length="10"
                               :required="false"
                               :valueType="Ctrls.InputTypes.Alphanumeric"/>
                        </v-col>
                        <v-col :cols=6 class="px-2">
                            <dd-text-box
                               label="発注番号"
                               placeholder=""
                               v-model="conditions.hachuBango"
                               :length="10"
                               :required="false"
                               :valueType="Ctrls.InputTypes.Alphanumeric"/>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
            <v-row no-gutters align-content="center">
                <v-col :cols=3>
                    <v-row no-gutters align-content="center">
                        <v-col :cols=12 class="px-2">
                            <dd-code-text-box
                              label="荷主コード/名称"
                              placeholder="名称またはコードで検索"
                              v-model="conditions.ninushiCd"
                              :length="10"
                              :required="false"
                              :titleText="荷主コード検索"
                              :valueType="Ctrls.InputTypes.Alphanumeric"/>
                        </v-col>
                    </v-row>
                </v-col>
                <v-col :cols=3>
                    <v-row no-gutters align-content="center">
                        <v-col :cols=12 class="px-2">
                            <dd-code-text-box
                              label="発地コード/名称"
                              placeholder="名称またはコードで検索"
                              v-model="conditions.hatsuchiCd"
                              :length="10"
                              :required="false"
                              :titleText="発地コード検索"
                              :valueType="Ctrls.InputTypes.Alphanumeric"/>
                        </v-col>
                    </v-row>
                </v-col>
                <v-col :cols=3>
                    <v-row no-gutters align-content="center">
                        <v-col :cols=12 class="px-2">
                            <dd-code-text-box
                                  label="卸先コード/名称"
                                  placeholder="名称またはコードで検索"
                                  v-model="conditions.oroshisakiCd"
                                  :length="10"
                                  :required="false"
                                  :titleText="発地コード検索"
                                  :valueType="Ctrls.InputTypes.Alphanumeric"/>
                        </v-col>
                    </v-row>
                </v-col>
                <v-col :cols=3>
                    <v-row no-gutters align-content="center">
                        <v-col :cols=12 class="px-2">
                            <dd-code-text-box
                              label="着地コード/名称"
                              placeholder="名称またはコードで検索"
                              v-model="conditions.chakuchiCd"
                              :length="10"
                              :required="false"
                              :titleText="着地コード検索"
                              :valueType="Ctrls.InputTypes.Alphanumeric"/>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
            <v-row no-gutters>
                <v-col :cols=7>
                    <v-row no-gutters align-content="left">
                        <v-col class="px-2">
                            <v-radio-group v-model="conditions.sagyoSinchoku" label="作業進捗" row>
                                <dd-radio-button style="width:15%" label="全て" value="9"></dd-radio-button>
                                <dd-radio-button style="width:15%" label="予定なし" value="1"></dd-radio-button>
                                <dd-radio-button style="width:15%" label="予定済" value="2"></dd-radio-button>
                                <dd-radio-button style="width:15%" label="計画済" value="3"></dd-radio-button>
                                <dd-radio-button style="width:15%" label="作業中" value="4"></dd-radio-button>
                                <dd-radio-button style="width:15%" label="作業完了" value="5"></dd-radio-button>
                                <dd-radio-button style="width:15%" label="確認済" value="6"></dd-radio-button>
                            </v-radio-group>
                        </v-col>
                    </v-row>
                </v-col>
                <v-col :cols=3>
                    <v-row no-gutters align-content="left">
                        <v-col class="px-2">
                            <v-radio-group v-model="conditions.seikyuJokyo" label="請求状況" row>
                                <dd-radio-button  style="width:20%;" label="全て" value="0"></dd-radio-button >
                                <dd-radio-button  style="width:20%;" label="未" value="1"></dd-radio-button >
                                <dd-radio-button  style="width:20%;" label="済" value="2"></dd-radio-button >
                            </v-radio-group>
                        </v-col>
                    </v-row>
                </v-col>
                <v-col :cols=2>
                    <v-row no-gutters align-content="center">
                        <v-toolbar class="pa-0 ma-0" flat dense>
                            <v-spacer />
                            <dd-default-button
                                @click="onSearchButtonClick">
                                検索
                            </dd-default-button>
                            <dd-default-button
                                @click="onClearButtonClick">
                                クリア
                            </dd-default-button>
                        </v-toolbar>
                    </v-row>
                </v-col>
            </v-row>
        </v-expansion-panel-content>
    </v-expansion-panel>
    <v-expansion-panel>
        <v-expansion-panel-header>
            <v-row no-gutters>
                <v-col :cols=6>
                    <dd-sub-header>
                      一覧
                    </dd-sub-header>
                </v-col>
                <v-col :cols=1></v-col>
                <v-col :cols="3">
                    <dd-narrow-down-text-box
                        v-model="searchText"/>
                </v-col>
                <v-col :cols="1">
                    <dd-row-count-box
                          label="検索結果"
                          v-model="rowCount"/>
                </v-col>
                <v-col :cols="1">
                    <dd-row-count-box
                          label="絞込結果"
                          v-model="filteredRowCount"/>
                </v-col>

            </v-row>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
            <v-row no-gutters>
                <v-col>
                    <dd-data-table
                        item-key="jutyuCd"
                        @click:row="onRowClick"
                        :height="tableHeight"
                        :headers="headers"
                        :items="filteredRows"
                        :search="searchText"
                        :custom-filter="filtering"/>
                </v-col>
            </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-row>

  <v-footer color="#FFFFFF" app inset>
    <v-row ref="_calcFooter">
        <dd-footer-button
          :disabled="isCsvButtonDisabled"
          @click="onCsvButtonClick">
          CSV出力
        </dd-footer-button>
        <a
          id="download"
          href="#"
          style="display:none;"
          download="発着地マスタ一覧.csv">ダウンロード</a>

        <v-spacer/>

        <dd-footer-button
          @click="onCreateButtonClick">
          新規登録
        </dd-footer-button>
    </v-row>
  </v-footer>
</v-container>
</template>
<script>
import DdSubHeader from '@/components/DdSubHeader'
import DdTextBox from '@/components/DdTextBox'
import DdCodeTextBox from '@/components/DdCodeTextBox'
import DdDateBox from '@/components/DdDateBox'
import DdDefaultButton from '@/components/DdDefaultButton'
import DdNarrowDownTextBox from '@/components/DdNarrowDownTextBox'
import DdRowCountBox from '@/components/DdRowCountBox'
import DdFooterButton from '@/components/DdFooterButton'
import DdDataTable from '@/components/DdDataTable'
import DdRadioButton from '@/components/DdRadioButton'

import flowMixin from '@/mixins/flowMixins'

import filter from '@/rahmen/utils/filters'

export default {
  name: 'OrcJuchuList',
  mixins: [flowMixin],
  data: () => ({
    conditions: {
      juchuEigyoushoCd: '',
      juchuBiFrom: '',
      juchuBiTo: '',
      nyuryokuTantoushaCd: '',
      tokuisakiCd: '',
      sagyoYoteiBiFrom: '',
      sagyoYoteiBiTo: '',
      kyakusakiChumonBango: '',
      sagyoBango: '',
      hachuBango: '',
      ninushiCd: '',
      hatsuchiCd: '',
      oroshisakiCd: '',
      chakuchiCd: '',
      sagyoSinchoku: '9',
      seikyuJokyo: '0'
    },
    ex_panel: [0, 1]
  }),
  components: {
    DdSubHeader,
    DdTextBox,
    DdDefaultButton,
    DdNarrowDownTextBox,
    DdRowCountBox,
    DdFooterButton,
    DdDataTable,
    DdCodeTextBox,
    DdDateBox,
    DdRadioButton
  },
  computed: {
    filteredRows () {
      return this.rows.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      })
    },
    isCsvButtonDisabled () {
      return this.rows.length === 0
    }
  },
  created () {
    this.setEnableViewScroll(false)
    this.calcHeightTargets = ['calcRow1', 'calcRow2', 'calcRow3', 'calcFooter']
    this.Effects.loadStart()
    this.$store.dispatch('system/setViewTitle', '受注一覧')
    this.headers = [
      { width: '60px', text: '受注番号', value: 'juchu_no' },
      { width: '90px', text: '受注日', value: 'juchu_ymd' },
      { width: '90px', text: '受注営業所', value: 'juchu_eigyosho' },
      { width: '90px', text: '客先注文番号', value: 'chumon_no' },
      { width: '200px', text: '得意先', value: 'tokuisaki_name' },
      { width: '60px', text: '請求止', value: 'seikyu_tome_flg' },
      { width: '60px', text: '請求区分', value: 'ikkatsu_seikyu_flg' },
      { width: '90px', text: '請求予定日', value: 'seikyu_yotei_ymd' },
      { width: '60px', text: '運賃確定状況', value: 'yubinNo' },
      { width: '60px', text: '請求状況', value: 'jusho' },
      { width: '90px', text: '請求金額', value: 'telNo' },
      { width: '90px', text: '受注契約番号', value: 'tantoshaNm' },
      { width: '90px', text: '作業明細番号', value: 'hacchakutiGroupCd' },
      { width: '90px', text: '発注番号', value: 'hacchakutiGroupCd' }]
    this.loadLoginInfo()
  },
  mounted () {
    this.refs = this.$refs
    this.loadFromCache('OrcJuchuList')
      .then((data) => {
        this.Effects.loadComplete()
      })
  },
  methods: {
    onSearchButtonClick: function (e) {
      this.Effects.loadStart()
      this.HttpClient
        .get('/api/v1/MstHacchakuchi/getAll', this.conditions)
        .then((data) => {
          this.rows = data.payload

          this.saveToChache('OrcJuchuList', { rows: this.rows, conditions: this.conditions })
            .then(() => {
              this.Effects.loadComplete()
            })
        })
    },
    onClearButtonClick: function (e) {
      this.conditions = {}
      this.searchText = ''
      this.rows = []
    },
    onRowClick: function (e) {
      console.log(e)
      this.Effects.loadStart()

      this.transition(0, { id: e.id })
    },
    onCsvButtonClick: function (e) {
      this.HttpClient
        .post('/api/v1/MstHacchakuchi/download', this.conditions)
        .then((data) => {
          const bom = new Uint8Array([0xEF, 0xBB, 0xBF])
          const blob = new Blob([bom, data], { type: 'text/csv' })
          const elem = document.getElementById('download')
          elem.href = window.URL.createObjectURL(blob)
          elem.click()
        })
    },
    onCreateButtonClick: function (e) {
      console.log(e)
    }
  }
}
</script>
